import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ToastService } from './toast.service';
import { ToastComponent } from './normal-toast/toast.component';
import { SuccessToastComponent } from './success-toast/success-toast.component';
import { WarningToastComponent } from './warning-toast/warning-toast.component';
import { ErrorToastComponent } from './error-toast/error-toast.component';

@NgModule({
  declarations: [ToastComponent, SuccessToastComponent, WarningToastComponent, ErrorToastComponent],
  imports: [CommonModule, MatSnackBarModule, MatButtonModule, MatIconModule],
  providers: [ToastService],
})
export class ToastModule {}
